import React, { useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import { PATH_LOGIN } from 'routes/paths'

// Services
import dialog from 'services/dialog'

// Icon
import IconLock from 'ui/Icons/IconLock'

const Expired = () => {
  const history = useHistory()

  useEffect(() => {
    dialog.alert({
      title: 'Your session has expired',
      message: 'Please re-login to renew your session.',
      icon: <IconLock />,
      onConfirm: async ({ setVisible }) => {
        setVisible(false)
        history.replace(PATH_LOGIN)
      },
    })
  }, [history])

  return <></>
}

export default Expired
